import type { Component } from 'vue';
import Comment from './Comment.vue';
import Dev from './Dev.vue';
import JJ from './JJ.vue';
import ProviderIcon from './ProviderIcon.vue';
export default new Map<string, Component>([
  ['Comment', Comment],
  ['JJ', JJ],
  ['ProviderIcon', ProviderIcon],
  ['Dev', Dev],

]);